<template>
  <b-table
    :data="entries"
    :loading="isLoading"
    :paginated="true"
    :backend-pagination="true"
    :total="totalCount"
    :per-page="pageSize"
    :current-page="page"
    :striped="true"
    @page-change="load"
  >
    <b-table-column field="when" label="Data si ora" v-slot="props">
      {{ props.row.when }}
    </b-table-column>
    <b-table-column field="user" label="Utilizator" v-slot="props">
      {{ props.row.user }}
    </b-table-column>
    <b-table-column field="action" label="Actiune" v-slot="props">
      {{ props.row.action }}
    </b-table-column>
    <b-table-column field="lines" label="Detalii" v-slot="props">
      <p v-if="props.row.reason">Motiv: {{ props.row.reason }}</p>
      <p
        v-for="(line, index) in props.row.lines"
        :key="index"
        class="is-size-7"
      >
        {{ line }}
      </p>
    </b-table-column>
    <template #empty>
      <p class="has-text-grey has-text-centered">
        {{ isLoading ? "Incarcare..." : "Nicio intrare in istoric" }}
      </p>
    </template>
  </b-table>
</template>

<script>
import SuccessionService from "@/services/succession.service";
import { notify } from "@/helpers/notify";
import { describeError } from "@/helpers/resdpsErrors";
import {
  auditActionLabel,
  fieldLabel,
  formatAuditValue,
  formatDateTime,
  fromApiUtc,
  isTechnicalField,
  userLabel,
} from "@/helpers/resdps";

const DETAIL_LABELS = {
  year: "An",
  rows: "Randuri",
  templateCode: "Sablon",
  templateVersion: "Versiune",
  fileName: "Fisier",
};

// Generarea unui document scrie DOUA intrari cu aceeasi actiune (DocumentGenerated): una pe dosar
// (SuccessionFile), cu schimbarile facute dosarului, alta pe documentul emis (GeneratedDocument), cu
// sablonul folosit - vezi SuccessionFileDocumentService.cs:116-126. Sufixul deosebeste a doua intrare,
// la fel cum " (pozitia din registru)" deosebeste ResdpsRegistration de dosar la inregistrare.
const ENTITY_TYPE_SUFFIXES = {
  ResdpsRegistration: " (pozitia din registru)",
  GeneratedDocument: " (documentul emis)",
};

export default {
  name: "SuccessionFileHistory",
  props: {
    fileId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      totalCount: 0,
      page: 1,
      pageSize: 20,
      isLoading: false,
    };
  },
  computed: {
    entries() {
      return this.items.map((item) => ({
        when: formatDateTime(fromApiUtc(item.occurredAtUtc)),
        user: userLabel(item.userEmail, item.userSub),
        action:
          auditActionLabel(item.action) +
          (ENTITY_TYPE_SUFFIXES[item.entityType] || ""),
        reason: item.reason,
        lines: (item.changes || [])
          .filter((change) => !isTechnicalField(change.field))
          .map(
            (change) =>
              fieldLabel(change.field) +
              ": " +
              formatAuditValue(change.field, change.old) +
              " → " +
              formatAuditValue(change.field, change.new)
          )
          .concat(
            Object.keys(item.details || {}).map(
              (key) => (DETAIL_LABELS[key] || key) + ": " + item.details[key]
            )
          ),
      }));
    },
  },
  created() {
    this.load(1);
  },
  methods: {
    // Citirea istoricului nu se jurnalizeaza (spec B, decizia B5); CNP-ul vine deja mascat.
    async load(page) {
      this.isLoading = true;
      try {
        const result = await SuccessionService.getAudit(
          this.fileId,
          page,
          this.pageSize
        );
        this.items = result.items;
        this.totalCount = result.totalCount;
        this.page = page;
      } catch (error) {
        notify.error(this, describeError(error).message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
